export default __webpack_public_path__ + "static/media/Logo.5fc6da55.png";